module.exports = __webpack_public_path__ + "img/52002756_L.30d152a2.png";